<section
  class="return-address-section"
  formGroupName="returnAddress"
  aria-labelledby="return-address-section-title"
>
  <div class="return-address-section__header">
    <div class="return-address-section__heading">
      <div id="return-address-section-title">
        <puro-typography
          class="return-address-section__title"
          variant="h2"
          component="h2"
          color="secondary"
        >
          {{ 'createShipment.sections.returnAddress.title' | translate }}
        </puro-typography>
      </div>
      <p class="return-address-section__required-legend">
        <span class="return-address-section__required-mark" aria-hidden="true">*</span>
        {{ 'createShipment.requiredFieldLegend' | translate }}
      </p>
    </div>

    <puro-button
      type="button"
      variant="primary"
      class="return-address-section__clear"
      data-clear-section="returnAddress"
      (buttonClick)="onClearForm()"
    >
      {{ 'createShipment.actions.clearForm' | translate }}
    </puro-button>
  </div>

  @if (addressSuggestion(); as suggestion) {
    <app-address-suggested-address-panel
      class="return-address-section__suggested-address"
      sectionRole="returnTo"
      [panelId]="suggestionPanelId"
      [displayLine]="suggestion.displayLine"
      [mode]="suggestion.mode"
      (useSuggested)="onUseSuggestedAddress()"
      (keepEntry)="onKeepSuggestedAddressEntry()"
    />
  }

  <app-form-error-summary
    [title]="'createShipment.validation.errorSummaryTitle' | translate"
    [messages]="sectionErrorMessages()"
  />

  <div class="return-address-section__grid">
    <app-street-address-autocomplete-field
      class="return-address-section__street"
      [label]="'createShipment.fields.streetAddress' | translate"
      formControlName="streetAddress"
      [inputName]="avsFieldName('streetAddress')"
      [required]="true"
      [fullWidth]="true"
      [error]="!!fieldError('streetAddress')"
      [errorMessage]="fieldError('streetAddress') ?? ''"
      [describedByIds]="streetDescribedByIds()"
      [listboxLabel]="'createShipment.fields.streetAddressSuggestions' | translate"
      (suggestionSelected)="streetAddressSuggestionSelected.emit($event)"
      (focusout)="onFieldBlur('streetAddress')"
    />

    <puro-input
      class="return-address-section__suite"
      [label]="'createShipment.fields.suiteAptUnit' | translate"
      formControlName="suiteAptUnit"
      [name]="avsFieldName('suiteAptUnit')"
      appDisableBrowserAutofill="disabled"
      [fullWidth]="true"
      [error]="!!fieldError('suiteAptUnit')"
      [errorMessage]="fieldError('suiteAptUnit') ?? ''"
      (focusout)="onFieldBlur('suiteAptUnit')"
    />

    <puro-input
      class="return-address-section__buzzer"
      [label]="'createShipment.fields.entryBuzzerCode' | translate"
      formControlName="entryBuzzerCode"
      [name]="avsFieldName('entryBuzzerCode')"
      appDisableBrowserAutofill="disabled"
      [fullWidth]="true"
      [error]="!!fieldError('entryBuzzerCode')"
      [errorMessage]="fieldError('entryBuzzerCode') ?? ''"
      (focusout)="onFieldBlur('entryBuzzerCode')"
    />

    <app-optional-address-lines
      [formGroup]="addressFormGroup"
      [expanded]="addressLinesExpanded()"
      [submitted]="submitted()"
      avsNamePrefix="returnAddress"
      (expandRequested)="onExpandAddressLines()"
    />

    <puro-input
      class="return-address-section__city"
      [label]="'createShipment.fields.city' | translate"
      formControlName="city"
      [name]="avsFieldName('city')"
      appDisableBrowserAutofill="disabled"
      [required]="true"
      [fullWidth]="true"
      [error]="!!fieldError('city')"
      [errorMessage]="fieldError('city') ?? ''"
      (focusout)="onFieldBlur('city')"
    />

    <app-floating-select
      class="return-address-section__province"
      formControlName="province"
      [label]="'createShipment.fields.province' | translate"
      [options]="provinceOptions()"
      [required]="true"
      [fullWidth]="true"
      [error]="!!fieldError('province')"
      [errorMessage]="fieldError('province') ?? ''"
      (focusout)="onFieldBlur('province')"
    />

    <puro-input
      class="return-address-section__postal"
      [label]="'createShipment.fields.postalCode' | translate"
      formControlName="postalCode"
      [name]="avsFieldName('postalCode')"
      appDisableBrowserAutofill="disabled"
      [required]="true"
      [fullWidth]="true"
      [error]="!!fieldError('postalCode')"
      [errorMessage]="fieldError('postalCode') ?? ''"
      (focusout)="onFieldBlur('postalCode')"
    />

    <app-phone-field-group
      class="return-address-section__phone"
      avsNamePrefix="returnAddress"
      [formGroup]="addressFormGroup"
      [phoneRequired]="phoneRequired()"
      [submitted]="submitted()"
    />
  </div>
</section>
